import React from 'react';

import { Container, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { intersection } from 'lodash';
import { Link } from 'react-router-dom';

import { userState } from '../../states/auth';
import { SCOPES } from '../../constants/scopes';

const styles = {
  primary: {
    color: '#000',
  },
  secondary: {
    color: '#a9a3a2',
  },
};

export default function LandingPage() {
  const user = useRecoilValue(userState);
  const userScopes = user?.user?.scopes || [];

  const menus = [
    {
      title: 'Incident',
      description: 'View all issues related to geocoding',
      href: '/incident/geocode-failed',
    },
    {
      title: 'Validate Address',
      description: 'Validate Address',
      href: '/validate-address',
    },
    {
      title: 'Dropoff Locations History',
      description: 'View the history of all drop-off locations',
      href: '/dropoff-locations-history',
      scopes: [SCOPES.ADMIN, SCOPES.SUPER_ADMIN],
    },
  ];

  return (
    <Container maxWidth="md" style={{ marginTop: '20px' }}>
      <List component="nav">
        {menus
          .filter((menu) => !menu.scopes || intersection(menu.scopes, userScopes)?.length > 0)
          .map((menu) => (
            <ListItem key={menu.title} disablePadding>
              <ListItemButton component={Link} to={menu.href}>
                <ListItemText
                  primary={menu.title}
                  secondary={menu.description}
                  slotProps={{
                    primary: { sx: styles.primary },
                    secondary: { sx: styles.secondary },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </Container>
  );
}
